
export default function Sectors() {
  const sectors = [
    {
      name: 'Industria Manufacturera',
      description: 'Suministros especializados para plantas de producción, talleres y líneas de manufactura con estándares de calidad industrial.',
      icon: 'ri-factory-line',
      image: 'https://public.readdy.ai/ai/img_res/5aff8bbb0b2015bc542c0e472274b5bd.jpg'
    },
    {
      name: 'Sector Salud',
      description: 'Productos de grado hospitalario para clínicas, hospitales y laboratorios que cumplen con normativas sanitarias estrictas.',
      icon: 'ri-hospital-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20hospital%20medical%20facility%20clean%20bright%20professional%20healthcare%20environment%20hygiene%20supplies%20white%20and%20blue%20tones%20minimalist%20corporate%20photography&width=600&height=400&seq=sector-healthcare-202&orientation=landscape'
    },
    {
      name: 'Sector Gubernamental',
      description: 'Abastecimiento confiable para instituciones públicas, oficinas gubernamentales y proyectos de infraestructura.',
      icon: 'ri-government-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20government%20building%20institutional%20facility%20clean%20professional%20public%20sector%20office%20white%20and%20blue%20tones%20minimalist%20corporate%20photography&width=600&height=400&seq=sector-government-203&orientation=landscape'
    },
    {
      name: 'Hotelería',
      description: 'Soluciones completas para hoteles, resorts y servicios de hospedaje que requieren estándares de limpieza premium.',
      icon: 'ri-hotel-line',
      image: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20lobby%20modern%20hospitality%20industry%20clean%20elegant%20professional%20environment%20white%20and%20blue%20tones%20minimalist%20corporate%20photography&width=600&height=400&seq=sector-hospitality-204&orientation=landscape'
    },
    {
      name: 'Industria Alimenticia',
      description: 'Químicos y suministros especializados para plantas procesadoras, cocinas industriales y servicios de alimentos.',
      icon: 'ri-restaurant-2-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20food%20processing%20facility%20industrial%20kitchen%20clean%20professional%20food%20industry%20environment%20white%20and%20blue%20tones%20minimalist%20corporate%20photography&width=600&height=400&seq=sector-food-205&orientation=landscape'
    },
    {
      name: 'Oficinas Corporativas',
      description: 'Insumos de limpieza e higiene para edificios corporativos, centros de negocios y espacios de trabajo profesionales.',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20professional%20workspace%20clean%20minimalist%20business%20environment%20white%20and%20blue%20tones%20corporate%20photography&width=600&height=400&seq=sector-corporate-206&orientation=landscape'
    },
    {
      name: 'Comercios',
      description: 'Productos de limpieza para centros comerciales, tiendas departamentales y espacios de retail de alto tráfico.',
      icon: 'ri-store-2-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20retail%20store%20shopping%20mall%20clean%20bright%20professional%20commercial%20space%20white%20and%20blue%20tones%20minimalist%20corporate%20photography&width=600&height=400&seq=sector-retail-207&orientation=landscape'
    },
    {
      name: 'Restaurantes',
      description: 'Químicos especializados y suministros para restaurantes, cafeterías y establecimientos de servicio de alimentos.',
      icon: 'ri-restaurant-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20restaurant%20professional%20kitchen%20clean%20bright%20food%20service%20industry%20white%20and%20blue%20tones%20minimalist%20corporate%20photography&width=600&height=400&seq=sector-restaurant-208&orientation=landscape'
    }
  ];

  return (
    <section id="sectores" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl sm:text-6xl font-light text-gray-900 mb-6">Sectores que atendemos</h2>
          <div className="w-20 h-0.5 bg-royal-600 mx-auto mb-8"></div>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto font-light">
            Soluciones especializadas para industrias que requieren cumplimiento, calidad y servicio profesional
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {sectors.map((sector, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-1 cursor-pointer border border-gray-200">
              <div className="w-full h-48 bg-gray-100 overflow-hidden">
                <img 
                  src={sector.image} 
                  alt={sector.name} 
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="w-12 h-12 bg-royal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${sector.icon} text-royal-600 text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{sector.name}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{sector.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-royal-600 to-navy-700 rounded-lg p-12 sm:p-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-4xl font-light text-white mb-6">¿Tu industria requiere soluciones específicas?</h3>
              <p className="text-white/90 text-base leading-relaxed mb-8 font-light">
                Contamos con experiencia atendiendo diversos sectores industriales y comerciales. Nuestro equipo puede desarrollar soluciones personalizadas que se adapten a tus procesos operativos y requerimientos normativos.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="tel:4499171543" className="px-8 py-4 bg-white text-royal-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors text-center whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line mr-2"></i>449 917 1543
                </a>
                <a href="https://wa.me/524492037021" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors text-center whitespace-nowrap cursor-pointer">
                  <i className="ri-whatsapp-line mr-2"></i>WhatsApp
                </a>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center border border-white/20">
                <div className="text-5xl font-light text-white mb-2">500+</div>
                <div className="text-white/80 text-sm font-light">Empresas Atendidas</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center border border-white/20">
                <div className="text-5xl font-light text-white mb-2">100+</div>
                <div className="text-white/80 text-sm font-light">Productos Industriales</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center border border-white/20">
                <div className="text-5xl font-light text-white mb-2">10+</div>
                <div className="text-white/80 text-sm font-light">Años de Experiencia</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center border border-white/20">
                <div className="text-5xl font-light text-white mb-2">4.8</div>
                <div className="text-white/80 text-sm font-light">Calificación Google</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
